'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { useMemo } from 'react';
import { GRANULARITY_OPTIONS, METRIC_OPTIONS } from '@/modules/finances/types';
import { BasicSelect } from '@/modules/shared/components/basic-select/basic-select';
import { DrawerSelect, FilterDrawer } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { MultipleSelector, type Option } from '@/modules/shared/components/form/multiselect';
import type { useBreakdownTableFilters } from './use-breakdown-table-filters';
const metricOptions: Option[] = Object.values(METRIC_OPTIONS).map(value => ({
  value,
  label: value,
  group: 'Metrics'
}));
const granularityOptions: Option[] = Object.values(GRANULARITY_OPTIONS).map(value => ({
  value,
  label: value,
  group: 'Granularity'
}));
interface BreakdownTableFiltersProps {
  filters: ReturnType<typeof useBreakdownTableFilters>;
}
function BreakdownTableFilters(t0) {
  const $ = _c(40);
  const {
    filters: t1
  } = t0;
  const {
    metrics,
    granularity,
    setMetrics,
    setGranularity,
    onReset,
    isResetDisabled
  } = t1;
  let t2;
  if ($[0] !== metrics) {
    t2 = metricOptions.filter(option => metrics.includes(option.value as METRIC_OPTIONS));
    $[0] = metrics;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedMetricOptions = t2;
  let t3;
  if ($[2] !== setMetrics) {
    t3 = options => {
      setMetrics(options.map(_temp));
    };
    $[2] = setMetrics;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleMetricsChange = t3;
  let t4;
  if ($[4] !== setMetrics) {
    t4 = values => {
      setMetrics(values as METRIC_OPTIONS[]);
    };
    $[4] = setMetrics;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleDrawerMetricsChange = t4;
  let t5;
  if ($[6] !== setGranularity) {
    t5 = value => {
      setGranularity(value as GRANULARITY_OPTIONS);
    };
    $[6] = setGranularity;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleDrawerGranularityChange = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      className: "md:w-48 lg:w-65"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleMetricsChange || $[10] !== selectedMetricOptions) {
    t7 = <MultipleSelector value={selectedMetricOptions} onChange={handleMetricsChange} options={metricOptions} enableSearch={false} groupBy="group" selectAllGroup="Metrics" placeholder="Metric" className="bg-background dark:bg-background" commandProps={t6} />;
    $[9] = handleMetricsChange;
    $[10] = selectedMetricOptions;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `granularity-${granularity}`;
  let t9;
  if ($[12] !== setGranularity) {
    t9 = value_0 => {
      setGranularity(value_0 as GRANULARITY_OPTIONS);
    };
    $[12] = setGranularity;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = Object.values(GRANULARITY_OPTIONS);
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== granularity || $[16] !== t8 || $[17] !== t9) {
    t11 = <BasicSelect key={t8} value={granularity} label="Granularity" onValueChange={t9} options={t10} placeholder="Monthly" className="md:w-27 lg:w-46" />;
    $[15] = granularity;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isResetDisabled || $[20] !== onReset) {
    t12 = <Button className="text-foreground/50 px-4 hover:bg-transparent dark:hover:bg-transparent" variant="ghost" onClick={onReset} disabled={isResetDisabled}>Reset Filter</Button>;
    $[19] = isResetDisabled;
    $[20] = onReset;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t7) {
    t13 = <div className="hidden items-center gap-4 md:flex">{t7}{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t7;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== handleDrawerMetricsChange || $[27] !== metrics) {
    t14 = <DrawerSelect value={metrics} onChange={handleDrawerMetricsChange} label="Metric" options={metricOptions} multiselect={true} />;
    $[26] = handleDrawerMetricsChange;
    $[27] = metrics;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== granularity || $[30] !== handleDrawerGranularityChange) {
    t15 = <DrawerSelect value={granularity} onChange={handleDrawerGranularityChange} label="Granularity" options={granularityOptions} />;
    $[29] = granularity;
    $[30] = handleDrawerGranularityChange;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== isResetDisabled || $[33] !== onReset || $[34] !== t14 || $[35] !== t15) {
    t16 = <div className="flex items-center gap-4 md:hidden"><FilterDrawer onReset={onReset} isResetDisabled={isResetDisabled}>{t14}{t15}</FilterDrawer></div>;
    $[32] = isResetDisabled;
    $[33] = onReset;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t13 || $[38] !== t16) {
    t17 = <div className="row flex gap-4">{t13}{t16}</div>;
    $[37] = t13;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp(option_0) {
  return option_0.value as METRIC_OPTIONS;
}
export { BreakdownTableFilters };